import { FriendInfo } from '@/api/types'

interface FriendListProps {
  friendsList: Record<string, FriendInfo[]>
  onFriendSelect: (friend: FriendInfo) => void
  selectedFriend: FriendInfo | null
  isLoading: boolean
  error: string
}

export default function FriendList({ 
  friendsList,
  onFriendSelect, 
  selectedFriend,
  isLoading,
  error
}: FriendListProps) {
  // 显示加载状态
  if (isLoading && Object.keys(friendsList).length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-500">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-2">加载中...</p>
        </div>
      </div>
    )
  }

  // 显示错误状态
  if (error) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-500">
        <div className="text-center">
          <svg className="mx-auto h-12 w-12 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="mt-2 text-red-600">{error}</p>
        </div>
      </div>
    )
  }

  // 按字母顺序排序分组
  const sortedGroups = Object.keys(friendsList).sort()

  if (sortedGroups.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-500">
        <div className="text-center">
          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <p className="mt-2">暂无好友</p>
        </div>
      </div>
    )
  }

  return (
    <div className="py-2">
      {sortedGroups.map((letter) => (
        <div key={letter} className="mb-1">
          {/* 分组标题 */}
          <div className="px-4 py-2 text-xs font-semibold text-gray-500 bg-gray-50 border-b border-gray-100">
            {letter}
          </div>
          
          {/* 好友列表 */}
          <div>
            {friendsList[letter].map((friend) => {
              const isSelected = selectedFriend && selectedFriend.id === friend.id
              const displayName = friend.alias || friend.nickname
              
              return (
                <div
                  key={friend.id}
                  onClick={() => onFriendSelect(friend)}
                  className={`
                    px-4 py-3 cursor-pointer transition-colors border-l-2
                    ${isSelected
                      ? 'bg-blue-50 border-l-blue-500' 
                      : 'border-l-transparent hover:bg-gray-50'
                    }
                  `}
                >
                  <div className="flex items-center space-x-3">
                    {/* 头像 */}
                    <div className="relative flex-shrink-0">
                      <img
                        src={friend.avatar || `https://via.placeholder.com/32/3b82f6/white?text=${displayName[0]?.toUpperCase() || '?'}`}
                        alt={displayName}
                        className="w-8 h-8 rounded-full"
                      />
                      {/* 在线状态 */}
                      {/* <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-gray-400 rounded-full border border-white"></div> */}
                    </div>
                    
                    {/* 好友信息 */}
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 truncate">
                        {displayName}
                      </p>
                      {/* 显示备注信息 */}
                      {friend.remark && (
                        <p className="text-xs text-gray-500 truncate">
                          {friend.remark}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </div>
  )
}
